// src/services/stockService.js - SECURED
import { API_BASE_URL } from '../utils/constants';


const getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      window.location.href = '/';
    }
    const error = await response.json();
    throw new Error(error.error || error.detail || 'Request failed');
  }
  return response.json();
};

export const stockService = {
  async getAllStocks() {
    try {
      const response = await fetch(`${API_BASE_URL}/stocks/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching all stocks:', error);
      throw error;
    }
  },

  // Get stock by symbol
  async getStockBySymbol(symbol) {
    try {
      const response = await fetch(`${API_BASE_URL}/stocks/symbol/${symbol}/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching stock by symbol:', error);
      throw error;
    }
  },

  // Get stocks by category
  async getStocksByCategory(category) {
    try {
      const response = await fetch(`${API_BASE_URL}/stocks/category/${category}/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching stocks by category:', error);
      throw error;
    }
  },

  async getTrendingStocks() {
    try {
      const response = await fetch(`${API_BASE_URL}/stocks/trending/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching trending stocks:', error);
      throw error;
    }
  },

  async getStockDetail(stockId) {
    try {
      const response = await fetch(`${API_BASE_URL}/stocks/${stockId}/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching stock detail:', error);
      throw error;
    }
  }
};